import { CustomFieldCollectionItemDataType } from "./CustomFieldDataTypeHelper/CustomFieldCollectionItemDataType";
import { CustomFieldContractorDataType } from "./CustomFieldDataTypeHelper/CustomFieldContractorDataType";
import { CustomFieldCustomDataType } from "./CustomFieldDataTypeHelper/CustomFieldCustomDataType/CustomFieldCustomDataType";
import { CustomFieldDataTypeHelper } from "./CustomFieldDataTypeHelper/CustomFieldDataTypeHelper";
import { CustomFieldDateDataType } from "./CustomFieldDataTypeHelper/CustomFieldDateDataType";
import { CustomFieldNorwegianStandardDataType } from "./CustomFieldDataTypeHelper/CustomFieldNorwegianStandardDataType";
import { CustomFieldNumberDataType } from "./CustomFieldDataTypeHelper/CustomFieldNumberDataType";
import { CustomFieldTagsDataType } from "./CustomFieldDataTypeHelper/CustomFieldTagsDataType";
import { CustomFieldTenantDataType } from "./CustomFieldDataTypeHelper/CustomFieldTenantDataType";
import { CustomFieldTextDataType } from "./CustomFieldDataTypeHelper/CustomFieldTextDataType";
import { t } from "i18next";

export class CustomFieldDataType {
  static readonly TEXT = new CustomFieldTextDataType("text", "✏️ " + t("main.customField_text"));
  static readonly NUMBER = new CustomFieldNumberDataType("number", "🔢 " + t("main.customField_number"));
  static readonly DATE = new CustomFieldDateDataType("date", "📅 " + t("main.customField_date"));
  static readonly LOCATION = new CustomFieldDataTypeHelper("location", "📍 " + t("main.customField_location"));
  static readonly TAGS = new CustomFieldTagsDataType("tags", "🏷️ " + t("main.customField_tags"));
  static readonly CONTRACTORS = new CustomFieldContractorDataType("contractors", "👷 " + t("main.contractors"));
  static readonly TENANTS = new CustomFieldTenantDataType("tenants", "🏬 " + t("main.tenant"));
  static readonly FORMULA = new CustomFieldDataTypeHelper("formula", "⚙️ " + t("main.customField_formula"));
  static readonly COLLECTION_ITEM = new CustomFieldCollectionItemDataType("collectionItems", "🔗 " + t("main.customField_collectionItem"));
  static readonly NORWEGIAN_STANDARDS = new CustomFieldNorwegianStandardDataType(
    "norwegianStandards",
    "🇳🇴 " + t("main.customField_norwegianStandards")
  );
  static readonly CUSTOM_DATA_TYPE = new CustomFieldCustomDataType("customDataType", "🔢 " + t("main.customDataType"));

  static readonly ALl_TYPES = [
    CustomFieldDataType.TEXT,
    CustomFieldDataType.NUMBER,
    CustomFieldDataType.DATE,
    CustomFieldDataType.LOCATION,
    CustomFieldDataType.TAGS,
    CustomFieldDataType.CONTRACTORS,
    CustomFieldDataType.TENANTS,
    CustomFieldDataType.FORMULA,
    CustomFieldDataType.COLLECTION_ITEM,
    CustomFieldDataType.NORWEGIAN_STANDARDS,
    CustomFieldDataType.CUSTOM_DATA_TYPE,
  ];
  static readonly FIELD_TYPES = [
    CustomFieldDataType.TEXT,
    CustomFieldDataType.NUMBER,
    CustomFieldDataType.DATE,
    CustomFieldDataType.TAGS,
    CustomFieldDataType.CONTRACTORS,
    CustomFieldDataType.TENANTS,
    CustomFieldDataType.NORWEGIAN_STANDARDS,
    CustomFieldDataType.CUSTOM_DATA_TYPE,
  ];

  static getTypeWithId(id: any): CustomFieldDataTypeHelper<any> {
    if (typeof id === "string") {
      const type = this.ALl_TYPES.find((type) => type.id === id);
      if (type) return type;
    }
    return CustomFieldDataType.TEXT;
  }
}

